<template>
	<div class="subject-container">
		<!-- 顶部搜索 + 操作 -->
		<div class="header-box">
			<el-button type="primary" @click="openAdd">+ 新增学科</el-button>
		</div>

		<!-- 列表 -->
		<el-table :data="list" border stripe>
			<el-table-column label="ID" prop="id" width="80" align="center" />
			<el-table-column label="学科名称" prop="subjectName" align="center" />
			<el-table-column label="学科logo" align="center">
				<template #default="{row}">
					<img :src="row.subjectLogo" class="logo-img" v-if="row.subjectLogo" />
					<span v-else>-</span>
				</template>
			</el-table-column>
			<el-table-column label="所属学段" align="center">
				<template #default="{row}">
					{{forpl(row.gradeRangeList)}}
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center">
				<template #default="{row}">
					<el-switch 
						v-model="row.status" 
						:active-value="1" 
						:inactive-value="0" 
						@change="updateStatus(row)"
						active-text="启用" 
						inactive-text="禁用" 
					/>
				</template>
			</el-table-column>
			<el-table-column label="默认开校创建" align="center" width="120">
				<template #default="{row}">
					<el-tag :type="row.defaultCreate === 1 ? 'success' : 'info'">
						{{ row.defaultCreate === 1 ? '是' : '否' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="200">
				<template #default="{row}">
					<el-button size="mini" type="primary" @click="openEdit(row)">编辑</el-button>
					<!-- <el-button size="mini" type="danger" @click="deleteItem(row.id)">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination 
			v-model:current-page="pageNum" 
			
			:total="total"
			layout="total, prev, pager, next, jumper" 
			
			@current-change="getList"
			style="margin-top:16px;text-align:right" 
		/>

		<!-- 新增/编辑弹窗 -->
		<el-dialog :visible.sync="dialogVisible" title="学科信息" width="600px" center>
			<el-form :model="form" ref="formRef" label-width="100px">
				<el-form-item label="学科名称" prop="subjectName">
					<el-input v-model="form.subjectName" style="width:300px" />
				</el-form-item>

				<el-form-item label="所属学段">
					<!-- 🔥 多选 + 编辑禁止删除已选中 -->
					<el-select 
						v-model="form.gradeRangeList" 
						multiple 
						style="width:300px"
						placeholder="请选择学段"
					>
						<el-option 
							v-for="item in gradeOptions" 
							:key="item.value"
							:label="item.label"
							:value="item.value"
							:disabled="form.id && form.gradeRangeList.includes(item.value)"
						/>
					</el-select>
				</el-form-item>

				<el-form-item label="状态">
					<el-radio-group v-model="form.status">
						<el-radio :label="1">启用</el-radio>
						<el-radio :label="0">禁用</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="默认开校创建">
					<el-radio-group v-model="form.defaultCreate">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>

			<div slot="footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitForm">确认保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'SubjectManage',
		data() {
			return {
				dialogVisible: false,
				form: {
					id:null,
					subjectName: '',
					subjectLogo: '',
					gradeRangeList: [],
					status: 1,
					defaultCreate: 0
				},
				// 学段下拉
				gradeOptions: [
					{ label: '小学', value: '1' },
					{ label: '初中', value: '2' },
					{ label: '高中', value: '3' },
					{ label: '中职', value: '4' },
				],
				pageSize: 10,
				pageNum: 1,
				total: 0,
				list: []
			}
		},
		created() {
			this.getList()
		},
		methods: {
			forpl(val){
				if(!val) return ''
				var arr=[]
				if(val.indexOf(1)>-1){
					arr.push('小学')
				}
				if(val.indexOf(2)>-1){
					arr.push('初中')
				}
				if(val.indexOf(3)>-1){
					arr.push('高中')
				}
				if(val.indexOf(4)>-1){
					arr.push('中职')
				}
				return arr.join(',')
			},
			// 打开新增
			openAdd(){
				this.form = {
					id:null,
					subjectName: '',
					subjectLogo: '',
					gradeRangeList: [],
					status: 1,
					defaultCreate: 0
				}
				this.dialogVisible = true
			},

			// 打开编辑
			openEdit(row){
				this.form = {
					...row,
					gradeRangeList: row.gradeRangeList ? row.gradeRangeList.split(',') : []
				}
				this.dialogVisible = true
			},

			// 获取列表
			async getList(pange) {
				if(pange){
					this.pageNum=pange
				}
				try {
					let res = await this.API.get(this.API.admin.getAdminSubjectList, {
						pageSize: this.pageSize,
						pageNum: this.pageNum
					})
					this.list = res.data.data.records || []
					this.total = res.data.data.total
				} catch (error) {
					this.list = []
				}
			},

			// 提交保存（自动拼接字符串）
			async submitForm() {
				
				try {
					let params = {
						...this.form,
						gradeRangeList: this.form.gradeRangeList.join(',')
					}
					console.log('222',params)
					// return 
					if(this.form.id){
						await this.API.post(this.API.admin.postAdminSubjectUpdate, params)
						this.$message.success('修改成功')
					}else{
						await this.API.post(this.API.admin.postAdminSubjectAdd, params)
						this.$message.success('新增成功')
					}
					this.dialogVisible = false
					this.getList()
				} catch (e) {
					this.$message.error('保存失败')
				}
			},

			// 修改状态
			async updateStatus(row){
				try{
					let res=await this.API.get(this.API.admin.getAdminSubjectStatus+row.id)
					
					this.$message.success(res.data.data)
				}catch(err){
					
				}
			},

			// 删除
			async deleteItem(id){
				await this.$confirm('确定删除吗?')
				await this.API.get(this.API.admin.getAdminSubjectDelete + id)
				this.$message.success('删除成功')
				this.getList()
			}
		}
	}
</script>

<style scoped>
	.subject-container {
		padding: 20px;
		background: #fff;
		min-height: calc(100vh - 60px);
	}

	.header-box {
		display: flex;
		gap: 10px;
		margin-bottom: 16px;
	}

	.logo-img {
		width: 32px;
		height: 32px;
		object-fit: contain;
	}
</style>